export default __webpack_public_path__ + "static/media/internet art.66066431.PNG";